export default class Preload extends Phaser.State {

    preload() {

        this.loaderBg = this.add.sprite(this.game.world.centerX, this.game.world.centerY, 'loaderBg');
        this.loaderBar = this.add.sprite(this.game.world.centerX, this.game.world.centerY, 'loaderBar');
        this.loaderBg.anchor.setTo(0.5);
        this.loaderBar.anchor.setTo(0.5);
        this.load.image('title', 'img/title.png');
        this.load.image('floor', 'img/floor.png');
        this.load.image('farback', 'img/farback.png');
        this.load.image('bg1', 'img/bg1.png');
        this.load.image('bg2', 'img/bg2.png');
        this.load.image('car', 'img/car.png');
        this.load.image('button', 'img/button.png');
        this.load.image('particle', 'img/particle.gif');
        this.load.image('logo', 'img/logo.png');
        this.load.image('plate', 'img/plate.png');
        this.load.image('heart', 'img/heart.png');
        
        // Load enemies
        this.load.image('fire-hydrant', 'img/fire-hydrant.png');
        this.load.image('barrier', 'img/obs.png');
        this.load.image('manhole', 'img/manhole.png');
        this.load.image('durian', 'img/durian.png');
        this.load.atlasJSONArray('cat', 'img/spritesheet/cat.png', 'data/spritesheet/cat.json');
        this.load.atlasJSONArray('snake', 'img/spritesheet/snake.png', 'data/spritesheet/snake.json');

        // load power
        this.load.image('coin1', 'img/coin1.png');
        this.load.image('coin2', 'img/coin2.png');
        this.load.image('angpao', 'img/angpao.png');
        this.load.image('bone', 'img/bone.png');

        // Load season entities
        this.load.image('city1', 'img/scenes/city1.png');
        this.load.image('city2', 'img/scenes/city2.png');
        this.load.image('city3', 'img/scenes/city3.png');
        this.load.image('city4', 'img/scenes/city4.png');

        this.load.image('back1', 'img/scenes/back1.png');
        this.load.image('back2', 'img/scenes/back2.png');
        this.load.image('back3', 'img/scenes/back3.png');
        this.load.image('beach-bg', 'img/scenes/beach-bg.png');
        this.load.image('desert-bg', 'img/scenes/desert-bg.png');
        this.load.image('winter-bg', 'img/scenes/winter-bg.png');
        this.load.image('desolated-bg', 'img/scenes/desolated-bg.png');
        this.load.image('city-bg', 'img/scenes/city-bg.png');
        this.load.image('city-bg2', 'img/scenes/city-bg2.png');
        this.load.image('end-house-background', 'img/end-house-1.png');
        this.load.image('end-house-foreground', 'img/end-house-2.png');

        this.game.load.script('BlurX', 'static/BlurX.js');
        this.game.load.script('BlurY', 'static/BlurY.js');

        this.load.setPreloadSprite(this.loaderBar);

        this.load.atlasJSONArray('doggo', 'img/spritesheet/doggo.png', 'data/spritesheet/doggo.json');
        this.load.atlasJSONArray('dog-red-fly', 'img/spritesheet/dog-red-fly.png', 'data/spritesheet/dog-red-fly.json');
        this.load.atlasJSONArray('dog-yellow', 'img/spritesheet/dog-yellow.png', 'data/spritesheet/dog-yellow.json');
        this.load.atlasJSONArray('dog-orange', 'img/spritesheet/dog-orange.png', 'data/spritesheet/dog-orange.json');
        this.load.atlasJSONArray('dog-orange-run', 'img/spritesheet/dog-orange-run.png', 'data/spritesheet/dog-orange-run.json');
        this.load.atlasJSONArray('poof', 'img/spritesheet/poof.png', 'data/spritesheet/poof.json');
        
        this.load.image('healthbar', 'img/healthbar.png');
        // this.load.image('hudBg', 'img/hud-bg.png');

        // background music
        this.load.audio('bgMusic', ['audio/music/bgMusic.mp3']);
        
        // sound effect
        this.load.audio('ObsHit', ['audio/sound/obstacle_hit.mp3']);
        this.load.audio('GameStart', ['audio/sound/Game_start.mp3']);
        this.load.audio('GameWin', ['audio/sound/Game_win.mp3']);
        this.load.audio('GameOver', ['audio/sound/Game_over.mp3']);

        this.load.audio('DogJump', ['audio/sound/Dog_jump.mp3']);
        this.load.audio('DogDoubleJump', ['audio/sound/Dog_doublejump.mp3']);

        this.load.audio('CoinSound', ['audio/sound/coinSound.mp3']);
        this.load.audio('DogHit', ['audio/sound/doghit.mp3']);
        this.load.audio('DogFly', ['audio/sound/flyingdog.mp3']);
        this.load.audio('DogSpeed', ['audio/sound/dogspeed.mp3']);

    }

    create() {
        this.state.start('PreSelection');
    }

}



// WEBPACK FOOTER //
// ./js/states/preload.js